export default __webpack_public_path__ + "static/media/face-detection.60b389df.png";